import LayoutDefault from '@/layouts/LayoutBase.vue';
// Auth
import auth from './auth';
// Configuração
import configuracao from './configuracao/index';
// Frota
import frota from './frota/index';

import dashboardRoute from './dashboard';

const AuthRoutes = Object.values(auth).map((route) => route[0]);
const configuracaoRoutes = Object.values(configuracao).map((route) => route[0]);
const frotaRoutes = Object.values(frota).map((route) => route[0]);

const routes = [].concat(
  dashboardRoute,
  AuthRoutes,
  configuracaoRoutes,
  frotaRoutes,
);

export default [{
  path: '/',
  component: LayoutDefault,
  children: routes,
}];
